import { EventTypeId, isActual as eventTypeIsActual } from '../interfaces/event/IEvent'

export function isActual(input: { eventType: EventTypeId }): boolean {
  return eventTypeIsActual(input.eventType)
}
